<div style="width:45vw">
  <h1>Please enter cupping session details</h1>
  <form #sessionForm="ngForm">
    <rms-date label="Session Date" [(ngModel)]="CuppingSession.SessionDate" name="sessionDate" [required]="true"></rms-date>
    <rms-number label="Number Of Tables" [(ngModel)]="CuppingSession.NumberOfTables" name="numberOfTables" [required]="true"></rms-number>
  </form>
  <div style="display:flex; width:100%; gap:10px">
    <button mat-button class="btn-bg-green" (click)="save()" [disabled]="!sessionForm.valid">Save</button>
    <button mat-button class="btn-bg-red" (click)="cancel()">Cancel</button>
  </div>
</div>
